"use strict";

var _regeneratorRuntime = require("/opt/build/repo/app/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfig = void 0;

var react_1 = __importDefault(require("react"));

var utility_1 = require("../utility");

var useConfig = function useConfig(shopifyPermanentDomain, preloadedConfig) {
  // synchronously returns cached and non-expired config from session storage
  var cachedConfig = react_1.default.useMemo(function () {
    var _a, _b;

    if (typeof window === "undefined") {
      return;
    }

    utility_1.debug.log("useConfig", "checking config cache");
    var sessionConfig = JSON.parse((_a = window.sessionStorage.getItem("reactify-search:config")) !== null && _a !== void 0 ? _a : "null");

    if (sessionConfig) {
      if (((_b = sessionConfig.config.cache) === null || _b === void 0 ? void 0 : _b.enabled) === false) {
        utility_1.debug.log("useConfig", "cache disabled, ignoring cached config");
        return;
      }

      utility_1.debug.log("useConfig", "cache enabled, using cached config");
      return sessionConfig.config;
    } else {
      utility_1.debug.log("useConfig", "cached config missing");
    }

    return;
  }, []);

  var _react_1$default$useS = react_1.default.useState(cachedConfig),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      config = _react_1$default$useS2[0],
      setConfig = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    (function () {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var searchParams, json;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                utility_1.debug.log("useConfig", "loading fresh config");
                searchParams = new URLSearchParams();
                searchParams.set("shop", shopifyPermanentDomain);
                _context.prev = 3;
                _context.next = 6;
                return fetch("https://config.usereactify.com/?".concat(searchParams.toString())).then(function (response) {
                  return response.json();
                });

              case 6:
                json = _context.sent;
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                utility_1.debug.log("useConfig", "error loading config, retrying...");
                _context.next = 14;
                return fetch("https://config.usereactify.com/?".concat(searchParams.toString())).then(function (response) {
                  return response.json();
                });

              case 14:
                json = _context.sent;

              case 15:
                setConfig(json.body);
                utility_1.debug.log("useConfig", "loaded fresh config");
                window.sessionStorage.setItem("reactify-search:config", JSON.stringify({
                  config: json.body
                }));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 9]]);
      }));
    })();
  }, [shopifyPermanentDomain]);
  react_1.default.useEffect(function () {
    utility_1.debug.log("useConfig", "config", config);
  }, [config]);
  return {
    config: config !== null && config !== void 0 ? config : preloadedConfig
  };
};

exports.useConfig = useConfig;